import { defineComponent as _defineComponent } from 'vue';
import { brightColors, colors } from "./colors";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ColorSelector',
    props: {
        color: null
    },
    emits: ["set-color"],
    setup(__props, { emit }) {
        const props = __props;
        function onClickColor(color) {
            emit("set-color", color);
        }
        return { __sfc: true, props, emit, onClickColor, brightColors, colors };
    }
});
